import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { useProjectCtx } from 'state/project/ProjectCtx';
import { AdminPortalConfig } from 'types/adminPortalConfig';
import { getStatic } from './api';
import { API_ROUTES, qk } from './apiRoutes';

const getAdminPortalConfig = async (
	projectId: string
): Promise<AdminPortalConfig> => {
	let projectLevelConfig: AdminPortalConfig = {};

	try {
		const res = await getStatic<AdminPortalConfig>(
			API_ROUTES.adminPortalConfig(projectId)
		);
		if (res.data) {
			projectLevelConfig = res.data;
		}
	} catch (err: any) {
		/* istanbul ignore next */
		if ((err as AxiosError).response?.status !== 404) {
			throw err;
		}
	}

	return projectLevelConfig;
};

export const useAdminPortalConfig = () => {
	const { projectId } = useProjectCtx();

	return useQuery({
		queryKey: qk.adminPortalConfig(),
		enabled: !!projectId,
		queryFn: () => getAdminPortalConfig(projectId!),
		staleTime: Infinity
	});
};
